import { put, select } from 'typed-redux-saga';

import { countMetrika } from '../../../../helpers/metrika';
import { debugHalt, hideDebugMenu, setDrawConferenceDisabledValue, showDebugMenu } from '../debug-menu/actions';
import { selectDrawConferenceDisabledValue } from '../debug-menu/selectors';

export function* dtmfOpenDebugMenuSaga() {
    countMetrika('dtmf', 'debug-menu', 'open');
    yield* put(showDebugMenu());
}

export function* dtmfCloseDebugMenuSaga() {
    countMetrika('dtmf', 'debug-menu', 'close');
    yield* put(hideDebugMenu());
}

export function* dtmfDebugMenuHaltSaga() {
    countMetrika('dtmf', 'debug-menu', 'halt');
    yield* put(debugHalt());
}

export function* dtmfDebugMenuToggleDrawingSaga() {
    const currentValue = yield* select(selectDrawConferenceDisabledValue);

    countMetrika('dtmf', 'debug-menu', 'toggle-drawing');
    yield* put(setDrawConferenceDisabledValue(!currentValue));
}
